import React, { Component } from "react";
import firebase from "../Firebase";
import { ReactComponent as Alert } from '../img/svg/alert.svg'

class Detail extends Component {
constructor(props) {
super(props);
this.ref = firebase.firestore().collection("test").where("waterTemperature", ">=", "70")
this.unsubscribe = null;
this.state = {
boards: [],
};

}

onCollectionUpdate = (querySnapshot) => {
const boards = [];
querySnapshot.forEach((doc) => {
const {
    activity,
    algae,
    dead,
    date,
    habitat,
    observation,
    river,
    section,
    startDate,
    temperature,
    waterTemperature,
    weather,
    fieldNotes
    

} = doc.data();
boards.push({
key: doc.id,
doc, // DocumentSnapshot
activity,
algae,
dead,
date,
habitat,
observation,
river,
section,
startDate,
temperature,
waterTemperature,
weather,
fieldNotes
});

});
this.setState({
boards,
});
};

componentDidMount() {
this.unsubscribe = this.ref.onSnapshot(this.onCollectionUpdate);
}

render() {
    

    return (
        <>
        <div className="body">
        <div className="alert center"><h1>2020 Hot Spots</h1></div>
                {this.state.boards.map((board) => (<>
            <div class="card">
                    <div className="card-heading">
                    <div className="col-3a">
            <div><Alert className="alert-icon"/></div>
            <div>
                <>{!board.otherRiver ? <>{board.river}</> : null} 
                {board.otherRiver && board.river ==="Other" ? <>{board.otherRiver}</> : null} </>



                        <>{board.section ? <>{board.section}</>: null }</></div>
                        <div ><p>Reported on: {board.date}</p></div>
                            </div>
                        <div>
                    </div>
                <div>
                    <div>
                  </div>
                </div>
                    </div>
        <div className="col-2-content">
            <div>
            {board.lat ? 
            <div>
                <p>Latitude: <b>{board.lat}</b> </p><p>Longitude: <b>{board.lon}</b></p>
            </div>
             : <p className="caption">no gps data</p>}
            </div>
            <div>
            <div className="temperature-display">
                        <>
                        <div className="temperature-display-hot temp-box">{board.waterTemperature}<sup>&deg;</sup></div> 
                        </>
                    </div>
            </div>
        </div>
        <div className="col-2-content">
            <div className="button-row-2a">
                </div>
            </div>
        </div>
        </>
        ))}
        </div>
        </>
        );
        }
        }
export default Detail;